<template>
  <div class="cycle_rank" v-if="clazz">
    <clazz-show-header :clazz="clazz" />

    <div class="my_stat bgwhite">
      <div v-if="type==1" class="label">本周排行榜</div>
      <div v-if="type==2" class="label">总排行榜</div>
      <div class="profile">
        <img v-lazy="userprofile.avatar_url" class="headimg">
        <div class="username">{{ userprofile.nickname }}</div>
      </div>
      <div class="stat">
        <div class="item">
          <div class="val">{{ myRank | myRankValue }}</div>
          <div class="key">排名</div>
        </div>
        <div class="item">
          <div class="val">{{ myRank | myRankDays }}</div>
          <div class="key">{{ rankCode | rankLabel }}</div>
        </div>
      </div>
      <!-- <div class="tabs">
        <div
          class="tab blue"
          :class="{yellow: type==1}"
          @click="changeType(1)"
        >本周排行榜</div>
        <div
          class="tab blue"
          :class="{yellow: type==2}"
          @click="changeType(2)"
        >总排行榜</div>
      </div> -->
    </div>

    <div class="rank_container bgwhite">
      <div class="header after_border">
        <div class="left">参与人数 {{ total }}</div>
        <rank-select v-model="rankCode" :clazz-type="clazz.clazz_type" @confirm="onConfirm"/>
        <!-- <div class="right" @click="onHelp">榜单说明</div> -->
      </div>

      <div v-if="rankCode" class="rank_list">
        <van-list
          v-model="loading"
          finished-text="没有更多了"
          :finished="finished"
          :immediate-check="true"
          @load="onLoad"
        >
          <rank-cell
            v-for="(item, index) in list"
            :key="index"
            :data="item"
            :rank-code="rankCode"
            :rank="index+1"
          />
        </van-list>
      </div>

    </div>

    <van-dialog v-model="show">
      积分说明
    </van-dialog>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { List, Dialog } from 'vant'
import ClazzShowHeader from '@/views/clazz/components/ClazzShowHeader'
import RankSelect from '@/views/clazz/components/RankSelect'
import RankCell from '@/views/clazz/components/RankCell'
import { clazzSimpleInfo, clazzMyWeekRank, clazzMyTotalRank, clazzWeekRank, clazzTotalRank } from '@/api/clazz'

export default {
  name: 'ClazzRank',
  components: {
    [List.name]: List,
    [Dialog.name]: Dialog,
    ClazzShowHeader,
    RankSelect,
    RankCell
  },
  filters: {
    myRankDays (value) {
      return value ? value.value : '-'
    },
    myRankValue (value) {
      return value ? value.rank : '-'
    },
    rankLabel (value) {
      if (value === 'day') {
        return '天数'
      } else if (value === 'distance') {
        return '距离（km）'
      } else if (value === 'duration') {
        return '时长'
      } else if (value === 'pace') {
        return '配速'
      } else if (value === 'num') {
        return '记录数'
      }
      return ''
    }
  },
  data () {
    return {
      rankCode: '',
      type: 2,
      clazzId: undefined,
      clazz: null,
      myRank: null,
      show: false,
      total: '',
      list: [],
      loading: false,
      finished: false,
      listQuery: {
        page: 0,
        size: 8
      }
    }
  },
  computed: {
    ...mapGetters([
      'userprofile'
    ])
  },
  created () {
    this.clazzId = this.$route.params.clazz_id || ''
    this.getClazzInfo()
    this.getMyRank()
  },
  methods: {
    async getClazzInfo () {
      let response = await clazzSimpleInfo(this.clazzId)
      this.clazz = response.data
    },
    onHelp () {
      this.show = true
    },
    getMyRank () {
      if (this.type === 1) {
        this.getMyWeekRank()
      } else {
        this.getMyTotalRank()
      }
    },
    getRankList () {
      if (this.type === 1) {
        this.getWeekRank()
      } else {
        this.getTotalRank()
      }
    },
    async getMyWeekRank () {
      let response = await clazzMyWeekRank(this.clazzId, { rank: this.rankCode })
      this.myRank = response.data
    },
    async getMyTotalRank () {
      let response = await clazzMyTotalRank(this.clazzId, { rank: this.rankCode })
      this.myRank = response.data
    },
    onLoad () {
      this.listQuery.page += 1
      this.getRankList()
    },
    async getWeekRank () {
      this.loading = true
      let response = await clazzWeekRank(this.clazzId, { rank: this.rankCode })
      this.loading = false
      this.list = this.list.concat(response.data.results)
      this.total = response.data.count
      this.checkFinished(response.data.count)
    },
    async getTotalRank () {
      this.loading = true
      let response = await clazzTotalRank(this.clazzId, { rank: this.rankCode })
      this.loading = false
      this.list = this.list.concat(response.data.results)
      this.total = response.data.count
      this.checkFinished(response.data.count)
    },
    checkFinished (total) {
      this.finished = this.list.length >= total
    },
    changeType (type) {
      if (this.type === type) {
        return false
      }
      this.type = type
      this.getMyRank()

      this.list = []
      this.listQuery.page = 0
      this.finished = false
    },
    onConfirm () {
      this.getMyRank()

      this.listQuery.page = 0
      this.finished = false
      this.list = []
      this.getRankList()
    }
  }
}
</script>

<style scoped lang="scss">
.cycle_rank {
  background-color: #f8f8f8;
  .my_stat{
    position: relative;
    box-sizing: border-box;
    width: 580px;
    margin: 30px auto 30px;
    padding: 30px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    .label {
      font-size: 32px;
      text-align: center;
      margin-bottom: 30px;
    }
    .profile {
      display: flex;
      flex-direction: column;
      align-items: center;
      .headimg {
        width: 100px;
        height: 100px;
        border-radius: 50%;
      }
      .username {
        font-size: 28px;
      }
    }
    .stat {
      width: 380px;
      font-size: 26px;
      color: #7d7e80;
      margin-top: 30px;
      display: flex;
      justify-content: space-between;
      .item {
        text-align: center;
        .val {
          color: #f5222d;
          font-weight: bold;
        }
      }
    }
    .tabs {
      position: absolute;
      width: 60px;
      top: 10px;
      bottom: 10px;
      right: -60px;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      .tab {
        color: #fff;
        padding: 0 15px;
        font-size: 25px;
        line-height: 28px;
        background-color: #f5222d;
        text-align: center;
        height: 165px;
        display: flex;
        align-items: center;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        &.blue {
          background: linear-gradient(to right, #5751e3 , #8075ea)
        }
        &.yellow {
          background: linear-gradient(to right, #ffb035 , #fdcd42)
        }
      }
    }
  }
  .rank_container {
    .header {
      padding: 30px 20px 30px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left {
        color: #b1b1b1;
        font-size: 26px;
        padding-left: 20px;
      }
      .right {
        color: #b1b1b1;
        font-size: 26px;
        border: 2px solid #f1f1f1;
        padding: 3px 12px;
        border-right-width: 0;
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;
      }
    }
  }
}
</style>
